import { render, staticRenderFns } from "./MixerLoadsList.vue?vue&type=template&id=08debbd0&"
import script from "./MixerLoadsList.vue?vue&type=script&lang=js&"
export * from "./MixerLoadsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports